import { render, staticRenderFns } from "./CollectionFilterControlTypeDate.vue?vue&type=template&id=35afcb34"
import script from "./CollectionFilterControlTypeDate.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionFilterControlTypeDate.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports